// extracted by mini-css-extract-plugin
export default {"container":"AddUser_container__cN02T","formGroup":"AddUser_formGroup__MIUhk","label":"AddUser_label__QB+eL","input":"AddUser_input__0dNY7","button":"AddUser_button__RBUqU"};